export default "__VITE_ASSET__7b6e4f83__"